// removed by extract-text-webpack-plugin
module.exports = {"icon-heading-wrapper":"IconHeading__icon-heading-wrapper","iconHeadingWrapper":"IconHeading__icon-heading-wrapper","icon-wrapper":"IconHeading__icon-wrapper","iconWrapper":"IconHeading__icon-wrapper","icon-bg":"IconHeading__icon-bg","iconBg":"IconHeading__icon-bg"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/IconHeading/IconHeading.scss
// module id = 1487
// module chunks = 8